<script setup lang="ts">
import { createTextVNode, defineComponent, watch } from 'vue';

import { ElMessage, ElMessageBox, ElNotification } from 'element-plus';
import { useThemeStore } from '@/store/modules/theme';

defineOptions({ name: 'AppProvider' });

// 使用主题store
const themeStore = useThemeStore();

// 监听主题变量变化并应用到html元素
watch(
  () => themeStore.cssVarsRef,
  (cssVars) => {
    // 将CSS变量应用到根元素
    const htmlElement = document.documentElement;
    // 直接获取对象的键值对进行遍历
    for (const key in cssVars) {
      if (Object.prototype.hasOwnProperty.call(cssVars, key)) {
        htmlElement.style.setProperty(key, cssVars[key]);
      }
    }
  },
  { immediate: true } // 组件挂载时立即执行一次
);

const ContextHolder = defineComponent({
  name: 'ContextHolder',
  setup() {
    function register() {
      window.$notification = ElNotification;
      window.$messageBox = ElMessageBox;
      window.$message = ElMessage;
    }

    register();

    return () => createTextVNode();
  }
});
</script>

<template>
  <div class="h-full">
    <ContextHolder />
    <slot></slot>
  </div>
</template>

<style scoped></style>
